import { isServer } from '.'

export enum envEnum {
  NEXT_PUBLIC_ENVIRONMENT = 'NEXT_PUBLIC_ENVIRONMENT',
  NODE_BACKEND_SERVER = 'NODE_BACKEND_SERVER',
  BROWSER_CRM_BACKEND_SERVER_RU = 'BROWSER_CRM_BACKEND_SERVER_RU',
  NODE_CRM_BACKEND_SERVER_RU = 'NODE_CRM_BACKEND_SERVER_RU',
  BROWSER_CRM_BACKEND_SERVER_KZ = 'BROWSER_CRM_BACKEND_SERVER_KZ',
  NODE_CRM_BACKEND_SERVER_KZ = 'NODE_CRM_BACKEND_SERVER_KZ',
  BROWSER_CRM_BACKEND_SERVER_UZ = 'BROWSER_CRM_BACKEND_SERVER_UZ',
  NODE_CRM_BACKEND_SERVER_UZ = 'NODE_CRM_BACKEND_SERVER_UZ',
  BROWSER_CRM_BACKEND_SERVER_UA = 'BROWSER_CRM_BACKEND_SERVER_UA',
  NODE_CRM_BACKEND_SERVER_UA = 'NODE_CRM_BACKEND_SERVER_UA',
  BROWSER_AUTH_BACKEND_SERVER_RU = 'BROWSER_AUTH_BACKEND_SERVER_RU',
  NODE_AUTH_BACKEND_SERVER_RU = 'NODE_AUTH_BACKEND_SERVER_RU',
  BROWSER_AUTH_BACKEND_SERVER_KZ = 'BROWSER_AUTH_BACKEND_SERVER_KZ',
  NODE_AUTH_BACKEND_SERVER_KZ = 'NODE_AUTH_BACKEND_SERVER_KZ',
  BROWSER_AUTH_BACKEND_SERVER_UZ = 'BROWSER_AUTH_BACKEND_SERVER_UZ',
  NODE_AUTH_BACKEND_SERVER_UZ = 'NODE_AUTH_BACKEND_SERVER_UZ',
  BROWSER_AUTH_BACKEND_SERVER_UA = 'BROWSER_AUTH_BACKEND_SERVER_UA',
  NODE_AUTH_BACKEND_SERVER_UA = 'NODE_AUTH_BACKEND_SERVER_UA',
}

export const getEnv = (env: envEnum): string => {
  const resp = isServer ? process.env[env] : window.process.env[env]

  if (resp) return resp
  throw new Error(`Empty env: ${env}`)
}
